<div id="sticky-footer" class="py-4 bg-dark text-white-50">
    <div class="container text-center">
        <small>Copyright &copy; www.darius-belgium.be</small>
    </div>
</div>